module.exports = __webpack_public_path__ + "img/MPX3.ac507d36.png";